import { useLocation } from "react-router-dom"
import Player from "./player/Player";
import { useEffect, useState } from "react";

export default () => {
    const location = useLocation();
    const { asset } = location.state;
    const [videoUrl, setVideoUrl] = useState(null);

    useEffect(() => {
        setVideoUrl(asset?.VideoPlaybackUrl != null ? asset.VideoPlaybackUrl : asset?.Videos.length > 0 ? asset.Videos[0]?.Url ?? '' : '');
    }, [videoUrl, asset]);

    if (!videoUrl) return null;

    return (
        <Player src={videoUrl} asset={asset} />
    )
}